import IconClaude from "@/app/(components)/generics/Icons/IconClaude";
import IconOpenAI from "@/app/(components)/generics/Icons/IconOpenAI";
import IconPlug from "@/app/(components)/generics/Icons/IconPlug";
import { UStyles } from "@/app/utils/UStyles";
import styles from "./BlogCover.module.css";

export default function BlogCoverTools() {
  return (
    <span className={styles.tools}>
      <span className={UStyles.classNames(styles.tool, styles.toolClaude)}>
        <IconClaude />
      </span>
      <span className={UStyles.classNames(styles.tool, styles.toolHub)}>
        <IconPlug />
      </span>
      <span className={styles.tool}>
        <IconOpenAI />
      </span>
    </span>
  );
}
